export const statusLabel: Record<string, string> = {
  PENDING: 'Requested',
  APPROVED_BY_TEACHER: 'Approved',
  APPROVED_BY_PRINCIPAL: 'Approved',
  COMPLETED: 'Dispersed',
  REJECTED: 'Rejected',
  CANCELLED: 'Cancelled',
};
